import React, { useState } from 'react';

import SearchForm from '../forms/SearchForm';

const HeaderSearchTemplate = () => {

    const [isSearchOpen, setSearchOpen] = useState(false);

    return (
        <>
            <div 
				className="header-search_btn show-search-button"
				onClick={() => setSearchOpen(!isSearchOpen)}
			>
				<i className={isSearchOpen ? "fal fa-search vis-head-search-close" : "fal fa-search"}></i>
				<span>{isSearchOpen ? "Close" : "Search"}</span>
			</div>

			<div 
				className={isSearchOpen ? "header-search_container header-search vis-head-search" : "header-search_container header-search vis-search"} 
			>
				<div className="container small-container">
					<div className="header-search_form fl-wrap">
						<SearchForm />
					</div>
					<div 
						className="header-search_close color5-bg"
						onClick={() => setSearchOpen(!isSearchOpen)}
					>
						<i className="fal fa-long-arrow-up"></i>
					</div>
				</div>
			</div>
        </>
    );
};

export default HeaderSearchTemplate;